export default __webpack_public_path__ + "static/4-6417a38218f7fb1a192a356e391ff9b9.png";